import { render, staticRenderFns } from "./widgets-list.vue?vue&type=template&id=a4202b50"
import script from "./widgets-list.vue?vue&type=script&lang=js"
export * from "./widgets-list.vue?vue&type=script&lang=js"
import style0 from "./widgets-list.vue?vue&type=style&index=0&id=a4202b50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports